import { Formik, Field, Form } from "formik";
import { initialHeaderTest } from "./helper";

export const ChooseToFilterTestPopup = ({
  setIsChooseToFilter,
  showHeaderTestArray,
  setShowHeaderTestArray,
}) => {
  const handleClose = () => {
    setIsChooseToFilter(false);
  };
  const headerArray = [
    "HA SKU Name",
    "Walk In Price",
    "MRP (Rs.)",
    "Outsourced",
    "Centre SKU Code",
    "Centre SKU Name",
    "HV Charges For",
    "Test Type",
  ];
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Choose To Filter Table</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik initialValues={{ numbers: showHeaderTestArray }}>
        {({ values, setFieldValue }) => {
          return (
            <Form>
              <div className="modal-body addusermodalbox">
                <div
                  className="select-time-interval"
                  style={{ height: "100%" }}
                >
                  {headerArray?.slice(4)?.map((ele, index) => (
                    <label className="labelselecttime" key={index}>
                      <Field
                        type="checkbox"
                        name="numbers"
                        key={ele}
                        value={ele}
                      />
                      <span className="selecttimespan">{ele}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
                <div>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    onClick={(e) =>
                      e.target.checked
                        ? setFieldValue(
                            "numbers",
                            headerArray.map((ele) => ele)
                          )
                        : setFieldValue("numbers", initialHeaderTest)
                    }
                    checked={headerArray?.length === values?.numbers?.length}
                  />
                  <label
                    className="margin-right"
                    style={{ marginLeft: "10px", fontWeight: "600" }}
                  >
                    Select All
                  </label>
                </div>
                <div>
                  <button
                    type="button"
                    className="savedetails"
                    onClick={() => {
                      setShowHeaderTestArray(
                        values?.numbers.length === 0
                          ? initialHeaderTest
                          : values?.numbers
                      );
                      setIsChooseToFilter(false);
                    }}
                  >
                    Show Selected
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
